import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faMinus,
  faExchangeAlt,
  faPlus
} from '@fortawesome/free-solid-svg-icons'

library.add(faMinus, faExchangeAlt, faPlus)

export default FontAwesomeIcon
